import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ProductComponent from "../product/ProductComponent";
import ProductComponentCopy from "../product/ProductComponentCopy";
import ProductQuickViewComponent from "../product/ProductQuickViewComponent";
import { getCategoriesFilterAction } from "../../State/actions/CategoriesFilterAction";
import { useMemo } from "react";
import PrimaryButton from "../PrimaryButton";
import Slider from "react-slick";
const TopProductsComponent = ({
  id,
  title,
  productType,
  relatedDiv,
  setRelatedDiv,
  showHideLoginForm,
  setshowHideLoginForm,
  loadingOnProductQuickPage,
  setloadingOnProductQuickPage,
  showBestQuickView,
  showProductQuickViewModal,
  showTrendingQuickView,
  triggerQuickViewModal,
}) => {
  const { bestSellingProducts, trendingProducts } = useSelector(
    (state) => state
  );

  const data =
    productType === "trending" ? trendingProducts : bestSellingProducts;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const clearCategoriesFilterAndRedirect = (id, categoryName) => {
    dispatch(getCategoriesFilterAction(id, categoryName));
    navigate(`/shop/${id}`, { replace: true });
  };

  const withStockItemClassName =
    "col-sm-3 col-6 col-xl-3 p-2 p-sm-0 homeProduct ";
  const withoutStockItemClassName =
    "col-sm-3 col-6 col-xl-3 p-2 p-sm-0 homeProduct OutOfStockProduct ";

  const sliderSettings = {
    slidesToShow: data.length <= 4 ? 4 : 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: data.length <= 4 ? false : true,
    autoplaySpeed: 2000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 2400,
        settings: {
          slidesToShow: data.length <= 5 ? 5 : 5,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: data.length <= 5 ? 5 : 5,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: data.length <= 5 ? 5 : 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const renderProductComponents = useMemo(() => {
    return data.map((productItemObj) => {
      return (
        // <ProductComponent
        //   productItemObj={productItemObj}
        //   id={id}
        //   key={productItemObj.productvarientid}
        //   triggerQuickViewModal={triggerQuickViewModal}
        //   setshowHideLoginForm={setshowHideLoginForm}
        //   setRelatedDiv={setRelatedDiv}
        //   productType={productType}
        //   withStockItemClassName={withStockItemClassName}
        //   withoutStockItemClassName={withoutStockItemClassName}
        //   imgKey={"image"}
        //   productNameKey={"productname"}
        //   categoryIdKey={"categoryid"}
        // />
        <ProductComponentCopy
          productItemObj={productItemObj}
          id={id}
          key={productItemObj.productvarientid}
          triggerQuickViewModal={triggerQuickViewModal}
          setshowHideLoginForm={setshowHideLoginForm}
          setRelatedDiv={setRelatedDiv}
          productType={productType}
          withStockItemClassName={withStockItemClassName}
          withoutStockItemClassName={withoutStockItemClassName}
          imgKey={"image"}
          productNameKey={"productname"}
          categoryIdKey={"categoryid"}
        />
      );
    });
  }, [
    data,
    id,
    triggerQuickViewModal,
    setshowHideLoginForm,
    setRelatedDiv,
    productType,
    withStockItemClassName,
    withoutStockItemClassName,
  ]);

  return (
    data &&
    data.length > 0 && (
      <div className="homeProductWrapper d-flex container">
        <div className="cardlist" style={{ width: "100%" }}>
          <div className="bestSelling">
            <div className="row justify-content-between col-12 m-0 align-items-center">
              <div className="col-md-6 text-start productWrapper my-0 ps-0">
                <h1 className="fs-6  fw-bolder lh-base">{title}</h1>
              </div>
              {/* <Link
                to="/shop"
                onClick={() => {
                  clearCategoriesFilterAndRedirect(0, "clear");
                }}
                className="col-md-6 desktopExplore text-end d-flex align-items-center justify-content-end"
              >
                <h4 type="button" className="fs-6 lh-base m-0 px-1">
                  View All
                </h4>
                <i className="material-icons">navigate_next</i>
              </Link> */}
            </div>
            <div className="productWrapper row g-1 d-flex">
              <ProductQuickViewComponent
                id={id}
                showProductQuickViewModal={showProductQuickViewModal}
                showTrendingQuickView={showTrendingQuickView}
                showBestQuickView={showBestQuickView}
                triggerQuickViewModal={triggerQuickViewModal}
                setloadingOnProductQuickPage={setloadingOnProductQuickPage}
                loadingOnProductQuickPage={loadingOnProductQuickPage}
                setshowHideLoginForm={setshowHideLoginForm}
                showHideLoginForm={showHideLoginForm}
                relatedDiv={relatedDiv}
                setRelatedDiv={setRelatedDiv}
              />
              <div className="clear"></div>

              <div
                // style={{ minHeight: data.length > 6 ? "650px" : "100%" }}
                className="gridTemplate"
              >
                <Slider {...sliderSettings}>{renderProductComponents}</Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default TopProductsComponent;
